import { render, staticRenderFns } from "./VoucherMoreInfoDrawer.vue?vue&type=template&id=72f08537&"
import script from "./VoucherMoreInfoDrawer.vue?vue&type=script&lang=js&"
export * from "./VoucherMoreInfoDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports